/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum ServiceOrderStatus {
    "OrderStatusCreated" = "created",
    "OrderStatusSearching" = "searching",
    "OrderStatusProcessing" = "processing",
    "OrderStatusCanceled" = "canceled",
    "OrderStatusCompleted" = "completed",
    "OrderStatusError" = "status_not_found"
}